import { useCallback, useRef } from "react";

// A prefill only replaces a value it wrote itself (or the loaded one), never one the user typed.
export const useAutoWrittenValue = <V>(initial: V) => {
  const autoValue = useRef(initial);

  const markWritten = useCallback((value: V) => {
    autoValue.current = value;
  }, []);

  const isUserValue = useCallback(
    (value: V) => value !== autoValue.current,
    [],
  );

  return { markWritten, isUserValue };
};
